import {
	Route,
	createBrowserRouter,
	createRoutesFromElements,
} from 'react-router-dom';
import Login from '../../pages/login/login.page';
import InstallPage from '../../pages/install/install.page';
import ActionHandlerPage from '../action-handler/action-handler.page';
import SignUpPage from '../../pages/sign-up/sign-up.page';
import VerifyPage from '../../pages/verify/verify.page';
import Home from '../../pages/home/home.page';
import SellingDashboard from '../../pages/sell/sell.page';
import MainLayout from '../../layouts/main-layout';
import BuyingDashboard from '../../pages/buy/buy.page';
import NewSellPublication from '../../pages/new-publication/new-sell.page';
import NewBuyPublication from '../../pages/new-publication/new-buy.page';
import SellDetailPage from '../../pages/sell/sell-detail.page';
import BuyDetailPage from '../../pages/buy/buy-detail.page';
import PartialSellDetailPage from '../../pages/sell/partial-sell-detail.page';
import PartialBuyDetailPage from '../../pages/buy/partial-buy-detail.page';
import { EditUserPage } from '../../pages/edit-user.page';
import { ChangePassword } from '../../pages/change-password/change-password';
import UserManualPage from '../../pages/user-manual/user-manual.page';
import PrivateRoute from './PrivateRoute';

const router = createBrowserRouter(
	createRoutesFromElements(
		<Route path="/">
			<Route path="login" element={<Login />} />
			<Route path="install" element={<InstallPage />} />
			<Route path="/action" element={<ActionHandlerPage />} />
			<Route path="sign-up" element={<SignUpPage />} />
			<Route path="/verify" element={<VerifyPage />} />
			<Route path="faq" element={<UserManualPage />} />
			<Route element={<MainLayout />}>
				<Route element={<PrivateRoute />}>
					<Route path="" index element={<Home />} />
					<Route path="sell">
						<Route index element={<SellingDashboard />} />
						<Route path="new" element={<NewSellPublication />} />
						<Route path=":id" element={<SellDetailPage />} />
						<Route path=":id/partial" element={<PartialSellDetailPage />} />
					</Route>
					<Route path="buy">
						<Route index element={<BuyingDashboard />} />
						<Route path="new" element={<NewBuyPublication />} />
						<Route path=":id" element={<BuyDetailPage />} />
						<Route path=":id/partial" element={<PartialBuyDetailPage />} />
					</Route>
					<Route path="edit-user" element={<EditUserPage />} />
					<Route path="change-password" element={<ChangePassword />} />
				</Route>
			</Route>
		</Route>,
	),
);

export default router;
